<template>
  <PdfReconstructedChapter
    page-title="受众研究学术研讨会"
    section-label="学科建设"
    :section-route="sectionRoute"
    layout-xml-path="/pdf/shouzhongyanjiu/layout.xml"
    :crop="crop"
    :pages="pages"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :manual-images="manualImages"
    :enhance-image-adjacent-text="false"
  />
</template>

<script>
import PdfReconstructedChapter from '@/components/PdfReconstructedChapter.vue';

export default {
  name: 'Lanhushouzhongyanjiu',
  components: {
    PdfReconstructedChapter
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      crop: {
        left: 76,
        right: 76,
        top: 150,
        bottom: 98
      },
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      pages: [{ pdfPage: 31, src: require('./assets/page-svg/page-031.jpg') }],
      manualImages: {
        31: [
          { left: 161, top: 257, width: 739, height: 246 },
          { left: 162, top: 522, width: 738, height: 324 }
        ]
      }
    };
  }
};
</script>
